<template>
  <trac-modal @close="$emit('close')">
    <h4 class="font-bold mb-8">Select Variation Mode</h4>
    <div class="mb-6">
      <div class="flex pb-3 mb-3 border-b border-b-primaryGray">
        <trac-radio
          name="variation-mode"
          :selectedVal="mode"
          :value="'option-mode'"
          @change="mode = $event"
        >
          <div>
            <h5 class="font-bold text-sm">Use Option Set</h5>
            <span
              >Create variations using existing or new option sets like size,
              colour, etc.</span
            >
          </div>
        </trac-radio>
      </div>
      <div>
        <trac-radio
          name="variation-mode"
          :selectedVal="mode"
          :value="'default-mode'"
          @change="mode = $event"
        >
          <div>
            <h5 class="font-bold text-sm">Create manually</h5>
            <span
              >Define product variations manually for this specific product
              without using option sets.</span
            >
          </div>
        </trac-radio>
      </div>
    </div>
    <trac-button class="w-full" :disabled="!mode" @button-clicked="saveMode">
      SAVE VARIATION MODE
    </trac-button>
  </trac-modal>
</template>

<script>
export default {
  name: 'SelectVariationMode',
  emits: ['close', 'update-mode'],
  data() {
    return {
      mode: '',
    };
  },
  methods: {
    saveMode() {
      this.$emit('update-mode', this.mode);
    },
  },
};
</script>

<style scoped></style>
